<template>
	<div class="roadmap" v-bind:class="{
		'roadmap--logged-out': !hasPermission,
		'roadmap--logged-in': hasPermission,
	}" @mousewheel="scrollHorizontally">

		<div class="roadmap__container">

			<!-- ----- Slides ----- -->

			<div class="roadmap__slide-wrap">
				<hero-banner v-if="bannerBgs" class="roadmap__slide" :backgrounds="bannerBgs"></hero-banner>
			</div>


			<!-- ----- Cards ----- -->

			<div ref="cards" class="roadmap__cards header--additive-padding" v-dragscroll.x="true" @dragscrollstart="onDragScrollStart" @dragscrollmove="onDragScroll($event.detail)"	@dragscrollend="onDragScrollEnd">
				<div class="page-container">

					<div class="roadmap__card-list" :class="{
						'roadmap__card-list--dragging' : cardsDragging,
					}">

						<div class="grid grid--g20--phab grid--g48--not-phab grid--s0 grid--auto grid--nowrap grid--middle">
							<div v-if="banner" class="grid__item">

								<div class="roadmap__intro">
									<div class="roadmap__intro-body">
										<div class="roadmap__intro-title" v-html="banner.title"></div>
										<div class="roadmap__intro-description" v-html="banner.description"></div>
										<div class="roadmap__intro-cta-wrap">
											<Btn v-if="!hasPermission" class="roadmap__intro-cta btn--shape--h48" @click.native="$root.$data.showLoginForm = true">Login to View</Btn>
											<Btn v-else-if="roadmapPDF" class="roadmap__intro-cta btn--shape--h48" :link="roadmapPDF" target="_blank">Download PDF</Btn>

										</div>
									</div>
								</div>

							</div>
							<template v-if="hasPermission">
								<div class="grid__item roadmap__card-wrap" v-if="keyData.game && keyData.game.assets.thumbnail.length > 0" v-for="(keyData, i) in gameKeys" :key="keyData.key">

									<div :ref="keyData.key" class="roadmap__card" :style="{ backgroundImage: 'url(' + keyData.game.assets.thumbnail[0].link + ')' }" @click="showGameDetail(keyData.game)">

										<div class="roadmap__card-tip">
											<div class="grid grid--b0 grid--auto grid--nowrap grid--middle">
												<div class="grid__item">
													<div class="roadmap__card-tip-type">
														{{keyData.game.gameType.includes('type-instant-win') ? 'Instant Win' : 'Casino Game'}}
													</div>
												</div>
												<div class="grid__item">
													<div class="roadmap__card-tip-availability" :class="{
														'roadmap__card-tip-availability--now' : keyData.game.regionalDisplayReleaseDate && keyData.game.regionalReleaseDate <= todayFormatted
													}">

														<!-- Regions -->
														<template v-if="keyData.game.regions && keyData.game.regions.length > 0">

															<!-- Live -->
															<template v-if="keyData.game.regionalDisplayReleaseDate && keyData.game.regionalReleaseDate <= todayFormatted">Now Live</template>

															<!-- Release Date -->
															<template v-else-if="keyData.game.regionalDisplayReleaseDate">{{keyData.game.regionalReleaseDate | formatDateShort}}</template>

															<!-- TBD -->
															<template v-else>TBD</template>

														</template>

														<!-- No Regions -->
														<template v-else>
															GLOBAL
														</template>
													</div>
												</div>
											</div>
										</div>

										<div class="roadmap__card-body">
											<div class="roadmap__card-meta">
												<div class="grid grid--g8 grid--auto grid--nowrap grid--middle grid--spread-between">
													<div class="grid__item">

														<div class="roadmap__card-title">{{keyData.game.gameName}}</div>
														<div class="roadmap__card-date">
															<template v-if="keyData.game.regions && keyData.game.regions.length > 0">
																<template v-if="keyData.game.regionalDisplayReleaseDate">{{keyData.game.regionalReleaseDate | formatDateShort}}</template>
																<template v-else>TBD</template>
															</template>
														</div>

													</div>
													<div class="grid__item">

														<div class="fonticon fonticon--plus--circle fs--40c"></div>

													</div>
												</div>
											</div>
										</div>

									</div>

								</div>
							</template>
						</div>

					</div>

				</div>
			</div>


			<!-- ----- Footer ----- -->

 			<div v-if="hasPermission" class="roadmap__footer" ref="footer">
	 			<div class="roadmap__footer-bar">
					<div class="roadmap__game-nav">
						<div class="grid grid--g80--desk grid--40--port grid--s0 grid--auto grid--nowrap grid--middle">
							<div class="grid__item">

								<div class="grid grid--b0 grid--auto grid--nowrap grid--middle">
									<template v-for="year in range(oldestYear, newestYear)">
										<template v-for="quarter in 4">
											<template v-for="month in range(3 * (quarter - 1), (3 * (quarter - 1)) + 2)">
												<template v-if="`${year}${zeroFill(month)}` >= `${oldestYear}${zeroFill(oldestMonth)}`">

													<div v-if="monthHasGames(year, quarter, month)" class="grid__item" :key="`${year}-${month}`">
														<div class="roadmap__game-nav-month">

															<div class="grid grid--b0 grid--auto grid--nowrap grid--middle">
																<template v-for="(game, index) in roadmap[year][quarter][month]">

																	<div class="grid__item">

																		<InfoTooltip v-if="gameIcon(game) && $mq == 'desk'" class="roadmap__icon-wrap" :canClose="false" theme="light">
																			<img class="roadmap__icon" :src="gameIcon(game)" />
																		</InfoTooltip>

																		<div v-if="index == 0" class="roadmap__game-nav-node" v-bind:class="{
																				'roadmap__game-nav-node--past' : currentGameKey && key(year, month, index) < currentGameKey,
																				'roadmap__game-nav-node--present' : currentGameKey && key(year, month, index) == currentGameKey,
																				'roadmap__game-nav-node--future' : !currentGameKey || key(year, month, index) > currentGameKey,
																			}" @click="scrollToGameByKey(key(year, month, index))">
																			<span class="roadmap__game-nav-title">
																				{{gameNavLabel(year, month)}}
																			</span>
																		</div>

								 										<div v-else class="roadmap__game-nav-dot" v-bind:class="{
																				'roadmap__game-nav-dot--past' : currentGameKey && key(year, month, index) < currentGameKey,
																				'roadmap__game-nav-dot--present' : currentGameKey && key(year, month, index) == currentGameKey,
																				'roadmap__game-nav-dot--future' : !currentGameKey || key(year, month, index) > currentGameKey,
																			}" @click="scrollToGameByKey(key(year, month, index))">
																		</div>
																	</div>

																	<div class="grid__item grid__item--grow">
																		<div class="roadmap__game-nav-line">
																			<div v-if="hasPermission" class="roadmap__game-nav-line-fill" v-bind:class="{
																				'roadmap__game-nav-line-fill--past' : currentGameKey && key(year, month, index) < currentGameKey,
																				'roadmap__game-nav-line-fill--present' : currentGameKey && key(year, month, index) == currentGameKey,
																				'roadmap__game-nav-line-fill--future' : !currentGameKey || key(year, month, index) > currentGameKey,
																			}" :style="{
																				width: (100 * currentGameFooterProgress) + '%'
																			}"></div>
																		</div>
																	</div>

																</template>
															</div>

														</div>
													</div>

												</template>
											</template>
										</template>
									</template>
								</div>

							</div>
						</div>

					</div>
				</div>

			</div>
		</div>



		<!-- ----- Game Info ----- -->

		<div v-if="hasPermission" class="roadmap__game-info-wrapper" v-bind:class="{
			'roadmap__game-info-wrapper--active': gameDetail != null
		}" ref="gameInfoScroller" @mousewheel.stop>

			<Btn class="roadmap__game-info-close btn--shape--h40 btn--style--custom" @click.native="gameDetail = null">
				<span class="roadmap__game-info-close-icon fonticon fonticon--close fs--14c"></span>
				<span class="fs--12c">Back to Roadmap</span>
			</Btn>

			<div v-if="gameDetail" class="grid grid--b0 grid--auto--not-phab grid--nowrap--not-phab grid--reverse--not-phab grid--v-spread-items--not-phab">
				<div class="grid__item grid__item--space df">

					<div class="roadmap__game-info-interact" :style="{ backgroundImage: 'url(' + gameInfoBackground + ')' }">

						<GameVideo v-if="($mq=='ltab' || $mq=='desk') && gameDetail.videoId" class="roadmap__game-info-video" :videoId="gameDetail.videoId" :autoPlay="false"></GameVideo>

						<btn v-else-if="($mq=='mob' || $mq=='ptab') && gameDetail.videoId" class="btn--style--fill--font btn--shape--h48" @click="watchVideo(gameDetail)">
							<span class="fonticon fonticon--play"></span>
							<span>Watch Video</span>
						</btn>

					</div>

				</div>
				<div class="grid__item">

					<div class="roadmap__game-info">
						<div class="page-container roadmap__game-info-centraliser">

							<div class="grid grid--s0">
								<div class="grid__item">

									<GameIntro :game="gameDetail" :showVolatilityRating="false"></GameIntro>

								</div>
								<div class="grid__item ">

									<GameInfo :game="gameDetail" gridClass="" gridItemClass="" :showAboutSection="false"></GameInfo>

								</div>
							</div>

						</div>
					</div>

				</div>
			</div>

		</div>

	</div>
</template>

<script>
import { mapGetters } from 'vuex'
import { has, get, forEach, find, findIndex, filter, orderBy, range } from 'lodash';
import { disableBodyScroll, clearAllBodyScrollLocks } from 'body-scroll-lock';
import ease from 'easy-ease';

import Btn from './atoms/Btn'
import HeroBanner from './organisms/HeroBanner'
import GameVideo from './molecules/GameVideo'
import GameIntro from './molecules/GameIntro'
import GameInfo from './molecules/GameInfo'
import InfoTooltip from './molecules/InfoTooltip'

export default {
	name: 'Roadmap',
	components: {
		Btn,
		HeroBanner,
		GameVideo,
		GameIntro,
		GameInfo,
		InfoTooltip,
	},
	data () {
		return {
			banner: null,
			roadmap: null,

			currentGameIndex: null,
			currentMonth: null,
			currentQuarter: null,
			currentYear: null,

			oldestMonth: null,
			oldestQuarter: null,
			oldestYear: null,
			newestGameIndex: null,
			newestMonth: null,
			newestQuarter: null,
			newestYear: null,
			startMonth: null,
			startQuarter: null,
			startYear: null,

			gameDetail: null,

			cardsDragging: false,
			cardsProgress: false,
		}
	},
	computed: {
		...mapGetters({
			'flatRegions': 'app/flatRegions',
		}),
		hasPermission: function()
		{
			return this.$root.userHasPermission({
				'igt': ['AM', 'CM', 'SA'],
				'operator': ['affiliate', 'customer', 'performance'],
			});
		},
		bannerBgs: function()
		{
			var desk = null;
			var mob = null;

			if(this.banner)
			{
				mob = this.banner.mobileBackgroundImage ? this.banner.mobileBackgroundImage.link : (this.banner.desktopBackgroundImage ? this.banner.desktopBackgroundImage.link : null);
				desk = this.banner.desktopBackgroundImage ? this.banner.desktopBackgroundImage.link : (this.banner.mobileBackgroundImage ? this.banner.mobileBackgroundImage.link : null);
			}

			return mob && desk ? {
				mob: mob,
				ptab: mob,
				ltab: desk,
				desk: desk,
			} : null;
		},
		gameInfoBackground: function()
		{
			if(!this.gameDetail) { return null; }

			var game = this.gameDetail;
			var withVidBg = null;
			var withoutVidBg = null;

			if(this.$mq == 'ltab' || this.$mq == 'desk')
			{
				withVidBg = game.assets.desktopHeroImage && game.assets.desktopHeroImage.length > 0 ? game.assets.desktopHeroImage[0].link: null;
				withoutVidBg = game.assets.roadmapDesktopImage && game.assets.roadmapDesktopImage.length > 0 ? game.assets.roadmapDesktopImage[0].link: null;
			}
			else if(this.$mq == 'mob' || this.$mq == 'ptab')
			{
				withVidBg = game.assets.mobileHeroImage && game.assets.mobileHeroImage.length > 0 ? game.assets.mobileHeroImage[0].link: null;
				withoutVidBg = game.assets.roadmapMobileImage && game.assets.roadmapMobileImage.length > 0 ? game.assets.roadmapMobileImage[0].link: null;
			}

			return game.videoId ? (withVidBg || withoutVidBg) : (withoutVidBg || withVidBg);
		},
		roadmapPDF: function()
		{
			return has(this.banner, 'cta.0.file.link') ? this.banner.cta[0].file.link : null;
		},
		monthsWithGames: function()
		{
			var result = [];
			forEach(this.roadmap, (quarters, year) =>
			{
				forEach(quarters, (months, quarter) =>
				{
					forEach(months, (games, month) =>
					{
						var key = `${year}-${this.zeroFill(parseInt(month)+1)}`;
						if(games && games.length > 0 && result.indexOf(key) == -1)
						{
							result.push(key);
						}
					});
				});
			});

			return result.sort();
		},
		gameKeys: function()
		{
			var result = [];
			forEach(this.roadmap, (quarters, year) =>
			{
				forEach(quarters, (months, quarter) =>
				{
					forEach(months, (games, month) =>
					{
						forEach(games, (game, index) =>
						{
							var key = this.key(year, month, index);
							result.push({
								key: key,
								index: parseInt(index),
								game: game,
								month: parseInt(month),
								quarter: parseInt(quarter),
								year: parseInt(year),
							});
						});
					});
				});
			});

			return result.sort();
		},
		todayFormatted: function()
		{
			return this.$moment().format('YYYY-MM-DD');
		},
		currentGameKey: function()
		{
			return this.currentGameIndex !== null ? this.key(this.currentYear, this.currentMonth, this.currentGameIndex) : null;
		},
		currentGameKeyIndex: function()
		{
			return this.currentGameKey ? findIndex(this.gameKeys, {key: this.currentGameKey}) : null;
		},
		currentGameMonth: function()
		{
			return `${this.currentYear}-${this.zeroFill(this.currentMonth + 1)}`;
		},
		currentGameMonthIndex: function()
		{
			return this.monthsWithGames.indexOf(this.currentGameMonth);
		},
		gameKeysInCurrentPeriod: function()
		{
			return filter(this.gameKeys, {
				year: this.currentYear,
				month: this.currentMonth,
			});
		},
		activeCardIndexFractional: function()
		{
			return this.cardsProgress * this.gameKeys.length;
		},
		activeCardIndexAbsolute: function()
		{
			return this.activeCardIndexFractional < 0 ? -1 : Math.max(0, Math.min(this.gameKeys.length - 1, Math.floor(this.activeCardIndexFractional)));
		},
		currentGameFooterProgress: function()
		{
			return this.activeCardIndexFractional < 0 ? 0 : Math.max(0, Math.min(1, this.activeCardIndexFractional - this.activeCardIndexAbsolute));
		},
		footerProgress: function()
		{
			if(this.currentGameIndex === null) { return 0; }

			var monthDivisions = 1 / Math.max(1, this.gameKeysInCurrentPeriod.length);
			var fractionalProgress = this.currentGameMonthIndex + (this.currentGameIndex * monthDivisions) + (this.currentGameFooterProgress * monthDivisions);
			var monthMarkerProgress = fractionalProgress / (this.monthsWithGames.length);

			return monthMarkerProgress;
		}
	},
	watch: {
		'$root.userSelectedRegionKey': function()
		{
			this.$root.appImmediateLoading = true;

			this.arrangeRoadmap();

			this.getPageContent()
			.then(success =>
			{
				this.$root.appImmediateLoading = false;
			});
		},
		gameDetail: function(to, from)
		{
			var self = this;

			self.$nextTick(function()
			{
				clearAllBodyScrollLocks();
				disableBodyScroll(to === true ? self.$refs.gameInfoScroller : self.$el);
			});
		},
		activeCardIndexAbsolute: function(to, from)
		{
			if(to !== from)
			{
				if(to === null || to < 0)
				{
					this.currentYear = null;
					this.currentQuarter = null;
					this.currentMonth = null;
					this.currentGameIndex = null;
				}
				else
				{
					var keys = this.gameKeys[to];
					this.setCurrentGame(keys.index, keys.month, keys.quarter, keys.year);
				}
			}
		},
		footerProgress: function(to, from)
		{
			if(this.$refs.footer)
			{
				this.$refs.footer.scrollLeft = to * (this.$refs.footer.scrollWidth - this.$refs.footer.clientWidth);
			}
		},
	},

	created: function () {

		var self = this;

		this.setRoadmapGames();

		this.getPageContent()
		.then(success =>
		{
			this.$root.$data.appLoading = false;
		});
	},
	mounted: function()
	{
		this.$eventBus.$on('delayed-window-resize', this.calculateCardsProgress);

		disableBodyScroll(this.$el);
		this.calculateCardsProgress();
	},
	beforeDestroy: function()
	{
		this.$eventBus.$off('delayed-window-resize', this.calculateCardsProgress);

		clearAllBodyScrollLocks();
	},
	methods: {
		range(start, end)
		{
			return range(start, end + 1);
		},
		zeroFill(number)
		{
			return ('00'+number).slice(-2);
		},
		key: function(year, month, index)
		{
			return `${year}-${this.zeroFill(parseInt(month)+1)}-${index}`;
		},
		getPageContent: function()
		{
			// Get Hero Data
			var params = this.$root.userSelectedRegion ? {
				regions: [
					this.$root.userSelectedRegion.key,
				],
				fallback: true,
			} : {
				fallback: true,
			};

			return this.$api.getRoadmappage(params).then((success) =>
			{
				this.banner = success.data.content[0];
			})
			.catch((error) =>
			{
				console.log(error);
			});
		},
		downloadRoadmapCsv: function()
		{
			var params = this.$root.userSelectedRegion ? {
				regions: [
					this.$root.userSelectedRegion.key,
				],
				fallback: true,
			} : {
				fallback: true,
			};

			return this.$api.downloadRoadmapCsv(params).then((success) =>
			{
				// do nothing
			})
			.catch((error) =>
			{
				console.log(error);
			});
		},
		setRoadmapGames: function()
		{
			// Get Roadmap games
			return this.$root.$data.gamesPromise
			.then((games) =>
			{
				this.arrangeRoadmap();
			})
			.catch((error) => {
				console.log(error);
			});
		},
		arrangeRoadmap: function()
		{
			var month;
			var quarter;
			var year;
			var now = this.$moment();
			var startOfMonth = now.startOf('month');
			var arrangedRoadmapGames = {};
			var roadmapGames = orderBy(filter(this.$root.games, (game) =>
			{
				var releaseDate = this.$moment(game.regionalReleaseDate);
				var inRegion = this.$root.userSelectedRegionKey ? find(game.regions, { region: this.$root.userSelectedRegionKey }) : true;

				return inRegion && game.roadmap == true && releaseDate.isSameOrAfter(startOfMonth);
			}), ['regionalReleaseDate', 'id'], ['asc', 'asc']);


			if(roadmapGames.length)
			{
				for(var index in roadmapGames)
				{
					var releaseDate = this.$moment(roadmapGames[index].regionalReleaseDate);
					// if(releaseDate.year() == now.year())
					// {
						month = releaseDate.month();
						quarter = releaseDate.quarter();
						year = releaseDate.year();

						// Put the game in a relevant place
						if(!arrangedRoadmapGames.hasOwnProperty(year)) { arrangedRoadmapGames[year] = {}; }
						if(!arrangedRoadmapGames[year].hasOwnProperty(quarter)) { arrangedRoadmapGames[year][quarter] = {}; }
						if(!arrangedRoadmapGames[year][quarter].hasOwnProperty(month)) { arrangedRoadmapGames[year][quarter][month] = []; }

						arrangedRoadmapGames[year][quarter][month].push(roadmapGames[index]);
					// }

					if(index == 0)
					{
						this.oldestMonth = month;
						this.oldestQuarter = quarter;
						this.oldestYear = year;
					}
				}

				this.newestMonth = month;
				this.newestQuarter = quarter;
				this.newestYear = year;
				this.newestGameIndex = arrangedRoadmapGames[year][quarter][month].length - 1;
			}

			this.roadmap = arrangedRoadmapGames;
			this.$refs.cards.scrollLeft = 0;
			this.calculateCardsProgress();
			this.gameDetail = null;
		},
		monthHasGames(year, quarter, month)
		{
			var games = get(this.roadmap, `${year}.${quarter}.${month}`);
			return games && games.length > 0;
		},
		gameNavLabel(year, month)
		{
			var date = this.$moment(`${year}-${this.zeroFill(month + 1)}-01`, 'YYYY-MM-DD');
			return date.format('MMMM') + (this.$moment().year() == year ? '' : ` ${year}`);
		},
		gameIcon(game)
		{
			return has(game, 'assets.icon.0.link') ? game.assets.icon[0].link : null;
		},
		setCurrentGame(newGameIndex, newMonth, newQuarter, newYear)
		{
			if(!this.hasPermission) { return; }

			var self = this;
			if(typeof newYear !== 'undefined') { self.currentYear = Number(newYear); }
			if(typeof newQuarter !== 'undefined') { self.currentQuarter = Number(newQuarter); }
			if(typeof newMonth !== 'undefined') { self.currentMonth = Number(newMonth); }
			self.currentGameIndex = Number(newGameIndex);
//			self.timerAmount = 0;
		},
		scrollToGameByKey(gameKey)
		{
			if(!this.hasPermission) { return; }

			var card = this.$refs[gameKey];

			if(card && card.length === 1)
			{
				card = card[0];
				var cardRect = card.getBoundingClientRect();
				var cardMid = cardRect.left + (cardRect.width / 2);
				var screenMid = this.$root.$data.windowWidth / 2;

				var from = this.$refs.cards.scrollLeft;
				var to = this.$refs.cards.scrollLeft - (screenMid - cardMid);

				ease({
					startValue: from,
					endValue: to,
					durationMs: 500,
					onStep: value => {
						this.$refs.cards.scrollLeft = value;
						this.calculateCardsProgress();
					},
				});
			}
		},
		watchVideo: function(game)
		{
			this.$root.$data.gameVideoId = game.videoId;

			this.trackEvent([
				'video-played',
				game.videoId,
				this.$root.$data.user ? this.$root.$data.user.trackName : null,
				0,
				false
			]);

			this.trackEvent([
				'game-video-played',
				game.gameName,
				this.$root.$data.user ? this.$root.$data.user.trackName : null,
				0,
				false
			]);
		},
		showGameDetail(game)
		{
			if(this.cardsDragging) { return; }
			this.gameDetail = game;
		},
		calculateCardsProgress()
		{
			var cards = this.$refs.cards;

			if(cards.scrollWidth <= cards.clientWidth)
			{
				this.cardsProgress = 0;
				return;
			}

			var firstCard = this.$refs[this.key(this.oldestYear, this.oldestMonth, 0)];
			var lastCard = this.$refs[this.key(this.newestYear, this.newestMonth, this.newestGameIndex)];

			if(firstCard && firstCard.length === 1 && lastCard && lastCard.length === 1)
			{
				firstCard = firstCard[0];
				lastCard = lastCard[0];
				var firstRect = firstCard.getBoundingClientRect();
				var lastRect = lastCard.getBoundingClientRect();

				var start = firstRect.left;
				var end = lastRect.left + lastRect.width;
				var winMidd = this.$root.$data.windowWidth / 2;

				this.cardsProgress = (winMidd - start) / (end - start);
			}

			// var progress = cards.scrollLeft / (cards.scrollWidth - cards.clientWidth);
			// this.cardsProgress =	Math.max(0, Math.min(100, ));
		},
		scrollHorizontally(evt)
		{
			if(!this.gameDetail)
			{
				evt.preventDefault();
				var delta = evt.wheelDelta || -evt.detail;
				this.$refs.cards.scrollLeft -= (delta / 2);			// Soften the scroll amount by halving the delta
				this.calculateCardsProgress();
			}
		},
		onDragScrollStart()
		{
			this.cardsDragging = true;
		},
		onDragScroll(delta)
		{
			this.calculateCardsProgress();
		},
		onDragScrollEnd()
		{
			setTimeout(() =>
			{
				this.cardsDragging = false;
			}, 0);
		},
	}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
	@import "src/scss/toolkit";

	$c: ".roadmap";
	#{$c}
	{
		background-color: palette(black);


		// Child components ---------------

		.hero-banner
		{
			.banner
			{
				background-color: transparent;
			}
		}



		// Child elements ---------------

		&__container
		{
			width: 100vw;
			height: 100vh;
		}

		&__slide-wrap
		{
			position: relative;
			width: 100%;
			height: 100%;
			z-index: 0;

			&:before
			{
				content: "";
				display: block;
				@include extend(absolute-fill);
				z-index: 2;
			}
		}

		&__slide
		{
			position: absolute;
			top: 0;
			left: 0;
			width: 100%;
		}

		&__intro
		{
			width: 648px;
			max-width: calc(100vw - 50px);
			color: palette('white');

			&-body
			{
				max-width: 420px;
			}

			&-title
			{
				@include extend(h1);
				margin-bottom: rem(24);
			}

			&-description
			{
				color: palette('light-grey');
				margin-bottom: rem(48);
			}
		}

		&__cards
		{
			position: absolute;
			width: 100%;
			height: 100%;
			top: 0;
			left: 0;
			@include extend(vertical-center);
			z-index: 1;
			overflow: hidden;
			pointer-events: none;

			@include media(phab)
			{
				padding-bottom: calc(78px + #{rem(20)});
			}

			@include media(not-phab)
			{
				padding-bottom: calc(120px + #{rem(20)});
			}
		}

		&__card-list
		{
			pointer-events: auto;
			cursor: grab;

			&--dragging
			{
				cursor: grabbing;
			}
		}

		&__card-wrap
		{
			&:last-child
			{
				padding-right: calc(50vw + 10px);

				@include media(not-phab)
				{
					padding-right: calc(50vw + 24px);
				}
			}
		}

		&__card
		{
			position: relative;
			width: 648px;
			max-width: calc(100vw - 50px);
			@include extend(bg-fill);
			background-position: center;
			box-shadow: 0 8px 16px 0 rgba(0,0,0,0.30);
			z-index: 0;

			#{$c}__card-list:not(#{$c}__card-list--dragging) &
			{
				cursor: pointer;
			}

			&:before
			{
				content: '';
				display: block;
				padding-top: 100% * (470/648);
			}

			&:after
			{
				content: "";
				@include extend(absolute-fill);
				z-index: 1;
				box-shadow: inset 0 0 0 0 rgba(1,121,255,0), 0 0 0 0 rgba(1,121,255,0);
				transition: box-shadow 0.15s ease-out;
			}

			&:hover:after
			{
				box-shadow: inset 0 0 0 2px rgba(1,121,255,1), 0 0 0 2px rgba(1,121,255,1);
			}

			&-body
			{
				position: absolute;
				left: 0;
				bottom: 0;
				display: flex;
				flex-wrap: nowrap;
				align-items: flex-end;
				width: 100%;
				padding: 0 rem(40) rem(32);
				background-image: linear-gradient(180deg, rgba(0,0,0,0) 0%, rgba(0,0,0,1) 100%);
				color: palette(white);
				opacity: 0;
				transition: opacity 0.25s ease-out;
				pointer-events: none;

				&:before
				{
					content: '';
					display: block;
					padding-top: 100% * (235 / 648);
				}

				#{$c}__card:hover &
				{
					opacity: 1;
				}
			}


			&-meta
			{
				width: 100%;
				opacity: 0;
				transform: translateY(30px);
				transition: all 0.25s ease-out;

				#{$c}__card:hover &
				{
					opacity: 1;
					transform: translateY(0);
				}
			}

			&-title
			{
				@include extend(heading);
				@include extend(h5-size);
				@include extend(lato-bold);
				margin-bottom: 2px;
			}

			&-date
			{
				@include extend(heading);
			}

			&-tip
			{
				position: absolute;
				top: 0;
				left: 50%;
				transform: translateX(-50%) translateY(-50%);
				@include extend(bgc-pal--white);
				border-radius: 9999px;
				@include extend(h6);
				font-size: 9px;
				line-height: (12/9);
				text-align: center;
				overflow: hidden;
				z-index: 2;

				&-type, &-availability
				{
					padding: 5px 10px 4px;
					min-width: 100px;
				}

				&-availability
				{
					@include extend(bgc-pal--font);

					&--now
					{
						@include extend(bgc-pal--blue);
					}
				}
			}
		}

		&__footer
		{
			position: fixed;
			bottom: 0;
			left: 0;
			width: 100%;
			z-index: 2;
			overflow: hidden;
			padding-top: rem(30);			// Allow for logo tooltips
			color: palette(black, contrast);
			background-color: transparentize(palette(black, base, true), 0.75);
			background-clip: content-box;

			#{$c}--logged-out &
			{
				pointer-events: none;
			}

			&-bar
			{
				@include media(phab)
				{
					padding: rem(46) 0 rem(20) rem(20);
				}

				@include media(not-phab)
				{
					padding: rem(60) 0 rem(48) rem(48);
				}
			}
		}

		&__icon-wrap
		{
			.info-tooltip
			{
				&__tooltip
				{
					text-align: center;
					width: 150px;
				}

				&__body
				{
					padding: rem(16);
				}

				&__content
				{
					padding: 0;
				}
			}
		}

		&__icon
		{
			max-width: 100%;
			max-height: 50px;
		}

		&__past
		{
			@include extend(h6);
			opacity: 0.75;
			transition: opacity 0.25s ease-out;

			&:hover
			{
				opacity: 1;
			}

			#{$c}--logged-out &
			{
				opacity: 0;
				transition: none;
				pointer-events: none;
			}
		}

		&__game-nav
		{
			&-month
			{
				width: 328px;
				max-width: 50vw;
			}

			&-node
			{
				position: relative;
				width: 12px;
				height: 12px;
				border: 2px solid transparentize(palette(white, base, true), 0.75);
				border-radius: 50%;
				cursor: pointer;

				&--past,
				&--present
				{
					#{$c}--logged-in &
					{
						border-color: palette(white);
					}
				}
			}

			&-dot
			{
				position: relative;
				width: 8px;
				height: 8px;
				background-color: transparentize(palette(white, base, true), 0.75);
				border-radius: 50%;
				cursor: pointer;

				&--past,
				&--present
				{
					#{$c}--logged-in &
					{
						background-color: palette(white);
					}
				}
			}

			&-title
			{
				@include extend(h6);
				position: absolute;
				bottom: calc(100% + #{rem(16)});
				white-space: nowrap;
				pointer-events: none;
			}

			&-line
			{
				height: 2px;
				background-color: transparentize(palette(white, base, true), 0.75);

				#{$c}--logged-in &
				{
					&-fill
					{
						width: 0%;
						height: 100%;
						background-color: palette(white);

						&--past { width: 100% !important; }
						&--future { width: 0% !important; }
					}
				}
			}
		}

		&__game-info
		{
			background-color: palette(white);
			width: 100vw;
			overflow-x: hidden;
			padding-top: rem(40);
			padding-bottom: rem(40);

			@include media(not-phab)
			{
				width: 640px;
				height: 100vh;
				overflow-y: scroll;
				-webkit-overflow-scrolling: touch;
			}

			@include media(ltab)
			{
				max-width: 50vw;
			}

			@include media(desk)
			{
				max-width: 40vw;
			}

			&-wrapper
			{
				position: fixed;
				width: 100%;
				height: 100%;
				left: 0;
				bottom: 0;
				z-index: 2000;
				transform: translateY(100%);

				@include media(phab)
				{
					height: 100vh;
					overflow-y: scroll;
					-webkit-overflow-scrolling: touch;
				}

				&--active
				{
					transform: translateY(0);

					@include css-variables
					{
						transition: transform calc(1s * #{var(base-trans-speed)});
					}
				}
			}

			&-centraliser
			{
				max-width: 536px + (2 * $page-padding);
			}

			&-close
			{
				position: absolute;
				padding-left: 0;
				background-color: transparentize(palette(white), 0.1);
				color: palette(font);

				@include media(phab)
				{
					top: rem(16);
					right: rem(16);
				}

				@include media(not-phab)
				{
					top: rem(24);
					right: rem(48);
				}

				&-icon
				{
					display: inline-flex;
					align-content: center;
					align-items: center;
					justify-content: center;
					width: rem(36);
					height: rem(36);
					text-align: center;
					border-radius: 50%;
					line-height: 1;
					background-color: palette(white);
				}

				& > *
				{
					padding-top: 0;
					padding-bottom: 0;
				}
			}

			&-interact
			{
				display: flex;
				align-items: center;
				align-content: center;
				justify-content: center;
				width: 100%;
				@include extend(bg-fill);
				background-position: center;
				background-color: palette(lightest-grey);

				@include media(phab)
				{
					max-height: 300px;

					&:before
					{
						content: '';
						display: block;
						width: 0;
						padding-top: 56%;
					}
				}
			}

			&-video
			{
				width: 100%;
				max-width: 1048px;
				background-color: transparent;
				box-shadow: none;

				.game-video__container
				{
					box-shadow: 0 4px 40px 0 rgba(0,0,0,0.40);
				}
			}

			.game-intro,
			.game-info__section
			{
				padding-top: rem(40);
				padding-bottom: rem(40);
			}

			.game-info__section
			{
				position: relative;

				&:before
				{
					display: none !important;
				}

				&:after
				{
					content: "";
					display: block;
					width: 100vw;
					position: absolute;
					left: -25vw;
					top: 0;
					border-bottom: 1px solid palette(lighter-grey);
				}
			}
		}

	}
</style>



// WEBPACK FOOTER //
// src/components/Roadmap.vue